import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventListChild from "./EventListChild";

const EventList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventList;
